var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",staticClass:"container-fluid p-0 m-0 ",attrs:{"id":"app"}},[_c('Nav'),_c('div',{staticClass:"row p-0 m-0 fullsize w-100 "},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }